import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function Audience() {
  const forWho = ["Profesionales con alta carga mental que sienten que su cerebro ya no 'arranca' como antes.", 'Emprendedores que necesitan enfoque total para tomar decisiones de alto nivel.', "Personas que 'comen saludable' pero siguen sintiéndose agotadas y sin explicación.", 'Cualquier persona que dependa del café para ser un ser humano funcional por la mañana.'];
  const notForWho = ['Quienes buscan un diagnóstico médico para enfermedades crónicas (esto es optimización nutricional).', 'Personas que no están dispuestas a ser constantes con su hidratación y soporte diario.', 'Quienes creen que una bebida energética de colores es la solución a su fatiga.'];
  return <section className="py-24 px-4 bg-forest text-offwhite" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-15">
          {/* Who this is for */}
          <FadeIn data-id="element-16">
            <div className="bg-forest-light/20 p-8 rounded-3xl border border-forest-light/30 h-full" data-id="element-17">
              <h3 className="font-serif text-2xl sm:text-3xl font-bold mb-8 text-amber-light" data-id="element-18">
                Para quién ES esto:
              </h3>
              <ul className="space-y-6" data-id="element-19">
                {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-20">
                    <CheckCircle2 className="text-amber shrink-0 mt-1" size={24} data-id="element-21" />
                    <span className="text-offwhite/90 leading-relaxed" data-id="element-22">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who this is NOT for */}
          <FadeIn delay={0.2} data-id="element-23">
            <div className="bg-black/20 p-8 rounded-3xl border border-white/10 h-full" data-id="element-24">
              <h3 className="font-serif text-2xl sm:text-3xl font-bold mb-8 text-offwhite/70" data-id="element-25">
                Para quién NO es:
              </h3>
              <ul className="space-y-6" data-id="element-26">
                {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-27">
                    <XCircle className="text-red-400 shrink-0 mt-1" size={24} data-id="element-28" />
                    <span className="text-offwhite/70 leading-relaxed" data-id="element-29">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}